import types from './types';

const initialState = {
  user: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_SUCCESS:
      const authObject = { ...action.payload };

      // Previously took the approach of deleting unserializable stuff, but
      // any JSAPI release could introduce more, so switching to instead only
      // pull off known/needed properties

      function getGroups(groups) {
        return groups.map(g => {
          return { id: g.id };
        });
      }

      const _user = authObject.user;
      const user = {
        isAdmin: _user.isAdmin,
        isAuthorized: _user.isAuthorized,
        culture: _user.culture,
        email: _user.email,
        fullName: _user.fullName,
        groups: getGroups(_user.groups),
        orgId: _user.orgId,
        thumbnail: _user.thumbnail,
        thumbnailUrl: _user.thumbnailUrl,
        url: _user.url,
        userContentUrl: _user.userContentUrl,
        userType: _user.userType,
        username: _user.username
      };

      return {
        ...state,
        user,
        loaded: true
      };
    case types.AUTH_FAIL:
      return {
        ...state,
        user: null,
        loaded: true
      };
    case types.LOGOUT:
      return {
        ...state,
        user: null
      };
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/redux/auth/reducers.js